mutation submitMultipleQuestion(
  $surveyCode: String!
  $questionId: Int!
  $value: [Int]
  $comment: String
  $isSkipped: Boolean
  $answerTimestamp: String!
) {
  submitMultipleQuestion(
    hashCode: $surveyCode
    questionId: $questionId
    selectedOptions: $value
    comment: $comment
    skippedQuestion: $isSkipped
    answerTimestamp: $answerTimestamp
  ) {
    success
    error
  }
}
